import React, { useState } from 'react';
import { FaEdit } from "react-icons/fa";
import {
    Button,
    Form,
    Input,
    Modal,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function EditFormModal({ data }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: ({ values, id }) => {

            axios
                .put(`/api/categories/${id}`, values)
                .then(() => {
                    queryClient.invalidateQueries(['/api/categories/'])
                    messageApi.open({
                        type: 'success',
                        content: 'Update successfully',
                        duration: 1,
                        onClose: () => setOpen(false)
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Update failed!',
                    });
                })
        }
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ values, id: data._id }))
    };

    const onCancelCreate = () => {
        setOpen(false);
    }
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<FaEdit />}
                style={{ color: '#5f77fc' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title="Update Category"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={onCreate}>
                        Ok
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={data}
                >
                    <Form.Item
                        name="name"
                        label="Category Name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="description" label="Description">
                        <Input type="textarea" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
